import McnAccount from '@/views/mcn/account'
import McnBDetail from '@/views/mcn/bdetail'
import McnEdit from '@/views/mcn/edit'
import McnIncome from '@/views/mcn/income'
// import McnIndex from '@/views/mcn/index'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 解决vue路由重复导航错误
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

const routes = [
  // mcn
  {
    path: '/',
    name: 'McnIndex',
    component: McnAccount
  },
  {
    path: '/mcn/account',
    name: 'McnAccount',
    component: McnAccount
  },
  {
    path: '/mcn/edit',
    name: 'McnEdit',
    component: McnEdit
  },
  {
    path: '/mcn/bdetail',
    name: 'McnBDetail',
    component: McnBDetail
  },
  {
    path: '/mcn/income',
    name: 'McnIncome',
    component: McnIncome
  },
  {
    path: '*',
    name: 'NoPage',
    component: () => import('../views/404.vue')
  }
]

const router = new Router({
  mode: 'history',
  routes
})

// router.beforeEach((to, from, next) => {
//   document.body.scrollTop = 0
//   // firefox
//   document.documentElement.scrollTop = 0
//   next()
// })

export default router



// WEBPACK FOOTER //
// ./src/router/mcn.js